// extracted by mini-css-extract-plugin
module.exports = {"container":"beach_container__31sjD","picture":"beach_picture__fhRzG","name":"beach_name__ek3Kr","gray":"beach_gray__2OhuZ"};